import Node from '~/scripts/services/model/node';

export default class KformTabAttributController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor($injector) {
		this.$injector = $injector;

		/** @type {boolean} */
		this.disabled = false;

		/** @type {?import('~/scripts/services/model/form').default} */
		this.form = null;

		this.kid = undefined;

		/** @type {?import('~/scripts/services/model/node').default} */
		this.node = null;
	}

	$onInit() {
		this.node = new Node(this.$injector);
		if (this.form) {
			this.node.attribut = this.form.attribut;
		}
	}
}
